import React from "react";
import { useIntl } from "react-intl";
import SeoHead from "~/components/seo/SeoHead";

export default function ProductsPageSeo() {
  const intl = useIntl();

  return (
    <SeoHead
      title={intl.formatMessage({ defaultMessage: 'Local Government Technology Products – Govlaunch', id: 'ns3WLU' })}
      description={intl.formatMessage({
        defaultMessage: 'Search local government technology products used by communities around the world.', id: 'MHjRHx',
      })}
    />
  );
}
